import { Icon } from "@mui/material";
import { iconClasses } from "@mui/material/Icon";
import { styled } from "@mui/material/styles";
import { Drawer } from "../../legacy/Drawer";

const PREFIX = "MessageBBJDrawer";
export const classes = {
  title: `${PREFIX}-title`,
  messagesSection: `${PREFIX}-messagesSection`,
  messagesWrapper: `${PREFIX}-messagesWrapper`,
  sendTextbox: `${PREFIX}-sendTextbox`,
  sendButton: `${PREFIX}-sendButton`,
  sendMessageWrapper: `${PREFIX}-sendMessageWrapper`,
  skeleton: `${PREFIX}-skeleton`,
  speechBubbleDetail: `${PREFIX}-speechBubbleDetail`,
};

export const MessageBBJDrawer = styled(Drawer)(({ theme }) => ({
  [`&.MuiDrawer-root`]: {
    zIndex: 1400,
  },
  [`& .MuiDrawer-paper`]: {
    zIndex: 1400,
    width: "420px",
  },
  [`& .${classes.title}`]: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(3),
  },
  [`& .${classes.messagesSection}`]: {
    position: "relative",
    width: 375,
    margin: theme.spacing(3),
    marginTop: theme.spacing(1),
    marginBottom: 0,
    flexWrap: "nowrap",
    flexGrow: 1,
    justifyContent: "space-between",
  },
  [`& .${classes.messagesWrapper}`]: {
    flexGrow: 1,
    flexWrap: "noWrap",
    position: "relative",
    flexDirection: "column-reverse",
    flexBasis: "0%",
    padding: theme.spacing(1),
  },
  [`& .${classes.sendTextbox}`]: {
    borderRadius: "8px",
    borderColor: "#E3E5EE",
  },
  [`& .${classes.sendButton}`]: {
    textAlign: "end",
    paddingTop: theme.spacing(1),
  },
  [`& .${classes.sendMessageWrapper}`]: {
    flexBasis: "0%",
    position: "sticky",
    zIndex: 2,
    bottom: 0,
    background: "white",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3),
  },
  [`& .${classes.skeleton}`]: {
    margin: theme.spacing(1),
    transform: "scale(1)",
    borderRadius: "8px",
    height: "55px",
  },
  [`& .${classes.speechBubbleDetail}`]: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    fontSize: "12px",
  },
}));

export const StatusIcon = styled(Icon, {
  shouldForwardProp: () => true,
})(({ color, theme }) => ({
  [`&.${iconClasses.root}`]: {
    marginLeft: "4px",
    fontSize: "20px",
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    color: color ? theme.palette[color][200] : "inherit",
  },
}));
